import F2 from "../Assets/Animations/F2.gif";
import F3 from "../Assets/Animations/F3.gif";
import F4 from "../Assets/Animations/F4.gif";
import F5 from "../Assets/Animations/F5.gif";
import F6 from "../Assets/Animations/F6.gif";
import F7 from "../Assets/Animations/F7.gif";
import F8 from "../Assets/Animations/F8.gif";
import F9 from "../Assets/Animations/F9.svg";

import aeroplane from "../Assets/Animations/aeroplane.json";
import parachutists from "../Assets/Animations/parachutists.json";
import rocket from "../Assets/Animations/rocket.json";

import darkAvatar from "../Assets/Images/darkAvatar.svg";

import FastWaterMarks from "../Assets/Images/FastWaterMarks.svg";
import ImageWaterMark from "../Assets/Images/ImageWaterMark.svg";
import fileWaterMarks from "../Assets/Images/fileWaterMarks.svg";
import fontsWaterMarks from "../Assets/Images/fontsWaterMarks.svg";
import logoWaterMarks from "../Assets/Images/logoWaterMarks.svg";
import textWaterMarks from "../Assets/Images/textWaterMarks.svg";

import dark from "../Assets/Images/dark-mode.svg";
import editingcontrol from "../Assets/Images/editing-control.svg";
import exif from "../Assets/Images/exif.svg";
import multiple from "../Assets/Images/export.svg";
import resolution from "../Assets/Images/high-quality-image.svg";
import multi from "../Assets/Images/multilingual.svg";
import qr from "../Assets/Images/qr-code.svg";
import friendly from "../Assets/Images/sleek-and-user-friendly.svg";
import trusted from "../Assets/Images/trusted-by-millions.svg";

export interface FeatureItem {
  title: string;
  sub_title1: string;
  sub_titlespan: string;
  sub_title2: string;
  description: string;
  extended?: string;
  image: string;
  bg: string;
  landing?: boolean;
}

export const Features: FeatureItem[] = [
  {
    title: "WatermarkImageTitle",
    sub_title1: "WatermarkImageSubTitle1",
    sub_titlespan: "WatermarkImageSubTitleSpan",
    sub_title2: "WatermarkImageSubTitle2",
    description: "WatermarkImageDescription",
    extended: "WatermarkImageDescriptionExtended",
    image: F2,
    bg: "bgTest",
    landing: true,
  },
  {
    title: "BatchWatermarkingTitle",
    sub_title1: "BatchWatermarkingSubTitle1",
    sub_titlespan: "BatchWatermarkingSubTitleSpan",
    sub_title2: "BatchWatermarkingSubTitle2",
    description: "BatchWatermarkingDescription",
    extended: "BatchWatermarkingDescriptionExtended",
    image: F3,
    bg: "bgTest",
    landing: true,
  },
  {
    title: "TemplateCreationTitle",
    sub_title1: "TemplateCreationSubTitle1",
    sub_titlespan: "TemplateCreationSubTitleSpan",
    sub_title2: "TemplateCreationSubTitle2",
    description: "TemplateCreationDescription",
    extended: "TemplateCreationDescriptionExtended",
    image: F4,
    bg: "bgTest",
    landing: true,
  },
  {
    title: "CreativeTitle",
    sub_title1: "CreativeSubTitle",
    sub_titlespan: "CreativeSubTitleSpan",
    sub_title2: "CreativeSubTitle2",
    description: "CreativeDescription",
    image: F5,
    bg: "bgTest",
  },
  {
    title: "SignatureTitle",
    sub_title1: "SignatureSubTitle1",
    sub_titlespan: "SignatureSubTitleSpan",
    sub_title2: "SignatureSubTitle2",
    description: "SignatureDescription",
    image: F6,
    bg: "bgTest",
  },
  {
    title: "FontsTitle",
    sub_title1: "FontsSubTitle1",
    sub_titlespan: "FontsSubTitleSpan",
    sub_title2: "FontsSubTitle2",
    description: "FontsDescription",
    image: F7,
    bg: "bgTest",
  },
  {
    title: "LogoTitle",
    sub_title1: "LogoSubTitle1",
    sub_titlespan: "LogoSubTitleSpan",
    sub_title2: "LogoSubTitle2",
    description: "LogoDescription",
    image: F8,
    bg: "bgTest",
  },
  {
    title: "AppsTitle",
    sub_title1: "AppsSubTitle1",
    sub_titlespan: "AppsSubTitleSpan",
    sub_title2: "AppsSubTitle2",
    description: "AppsDescription",
    image: F9,
    bg: "bgTest",
  },
];

export interface ReviewItem {
  name: string;
  img: string;
  description: string;
}

export const reviews: ReviewItem[] = [
  {
    name: "Sarah Jenkins",
    img: darkAvatar,
    description:
      "eZy Watermark has completely streamlined my workflow! The batch watermarking is incredibly fast, and I love that my high-res photos are processed right in the browser. Knowing my photos are safe and never sent to a server is a huge plus.",
  },
  {
    name: "Marcus Chen",
    img: darkAvatar,
    description:
      "Excellent app for protecting property photos. I created a custom template with our agency logo and contact info, and now I can watermark all listing images in under a minute. Simple, clean, and professional.",
  },
  {
    name: "Elena Rostova",
    img: darkAvatar,
    description:
      "The creative freedom on this web app is amazing. I can import my custom signatures, adjust transparency, and choose from a wide variety of fonts. Highly recommend it to fellow artists looking to protect their work.",
  },
  {
    name: "David Miller",
    img: darkAvatar,
    description:
      "I've tried many watermarking tools, but this is by far the most user-friendly. No complex installation is needed, and the subscription plans are very affordable. Setting up a yearly plan was a no-brainer for my brand.",
  },
  {
    name: "Amina Al-Jamil",
    img: darkAvatar,
    description:
      "Perfect for my e-commerce shop photos. The template auto-saving feature is a lifesaver. I can access my pre-set watermark templates on any device just by logging in. Extremely helpful!",
  },
  {
    name: "Tomás Ortega",
    img: darkAvatar,
    description:
      "I watermarked over a hundred travel photos in one go, and the image quality remained absolutely perfect. The batch editing feature lets me adjust the position on individual photos if needed. 10/10.",
  },
];

export interface FaqItem {
  question: string;
  answer: string;
  type: "faq";
  category: string;
}

// Single source for the /faq page (FAQExplorer + Questions). The pricing page no longer has
// its own FAQ block, so every entry is plain "faq" type now.
export const faqs: FaqItem[] = [
  { question: "Q1", answer: "A1", type: "faq", category: "Quality & Export" },
  { question: "Q2", answer: "A2", type: "faq", category: "Subscription" },
  { question: "Q3", answer: "A3", type: "faq", category: "General" },
  { question: "Q4", answer: "A4", type: "faq", category: "General" },
  { question: "Q5", answer: "A5", type: "faq", category: "Subscription" },
  { question: "Q6", answer: "A6", type: "faq", category: "Quality & Export" },
  { question: "Q7", answer: "A7", type: "faq", category: "General" },
  { question: "Q8", answer: "A8", type: "faq", category: "Templates & Files" },
  { question: "Q9", answer: "A9", type: "faq", category: "Subscription" },
  { question: "Q10", answer: "A10", type: "faq", category: "Quality & Export" },
  { question: "Q11", answer: "A11", type: "faq", category: "Quality & Export" },
  { question: "Q12", answer: "A12", type: "faq", category: "Templates & Files" },
  { question: "Q13", answer: "A13", type: "faq", category: "General" },
  { question: "Q14", answer: "A14", type: "faq", category: "Templates & Files" },
  { question: "Q15", answer: "A15", type: "faq", category: "Subscription" },
  { question: "Q16", answer: "A16", type: "faq", category: "Subscription" },
  { question: "Q17", answer: "A17", type: "faq", category: "AI & Smart" },
  { question: "Q18", answer: "A18", type: "faq", category: "AI & Smart" },
  { question: "Q19", answer: "A19", type: "faq", category: "Subscription" },
];

export interface PlanItem {
  title: string;
  price?: string;
  priceMonthly?: string;
  priceYearly?: string;
  recommended: boolean;
  bullets: string[];
  // Optional per-cycle overrides -- Monthly and Yearly grant genuinely different bullet
  // copy (Yearly highlights the annual-only value props). Falls back to `bullets` when absent.
  bulletsMonthly?: string[];
  bulletsYearly?: string[];
  animation: Record<string, unknown>;
}

export const plan: {
  freeplan: PlanItem;
  premPlan: PlanItem;
  enterprisePlan: PlanItem;
} = {
  freeplan: {
    title: "FreeTitle",
    price: "0",
    priceMonthly: "0",
    priceYearly: "0",
    recommended: false,
    bullets: ["Free1", "Free2", "Free3", "Free4"],
    animation: parachutists,
  },
  premPlan: {
    title: "PremTitle",
    price: "1.99",
    priceMonthly: "1.99",
    priceYearly: "19.99",
    recommended: true,
    bullets: [
      "Prem1", "Prem2", "Prem3", "Prem4", "Prem5", "Prem6", "Prem7",
      "Prem8", "Prem9", "Prem10", "Prem11", "Prem12", "Prem13", "Prem14",
    ],
    bulletsMonthly: [
      "PremMonthly1", "PremMonthly2", "PremMonthly3", "PremMonthly4",
      "PremMonthly5", "PremMonthly6", "PremMonthly7", "PremMonthly8",
    ],
    bulletsYearly: [
      "PremYearly1", "PremYearly2", "PremYearly3", "PremYearly4",
      "PremYearly5", "PremYearly6", "PremYearly7", "PremYearly8",
    ],
    animation: aeroplane,
  },
  enterprisePlan: {
    title: "EnterpriseTitle",
    recommended: false,
    bullets: ["Enterprise1", "Enterprise2"],
    animation: rocket,
  },
};

export interface MoreFeatureItem {
  title: string;
  description: string;
  img: string;
}

export const MoreFeaturesPricing: MoreFeatureItem[] = [
  {
    title: "ImageWaterMarkPriceFeatureTitle",
    description: "ImageWaterMarkPriceFeature",
    img: ImageWaterMark,
  },
  {
    title: "TextWaterMarkPriceFeatureTitle",
    description: "TextWaterMarkPriceFeature",
    img: textWaterMarks,
  },
  {
    title: "LogoWaterMarkPriceFeatureTitle",
    description: "LogoWaterMarkPriceFeature",
    img: logoWaterMarks,
  },
  {
    title: "FontsWaterMarkPriceFeatureTitle",
    description: "FontsWaterMarkPriceFeature",
    img: fontsWaterMarks,
  },
  {
    title: "FilesWaterMarkPriceFeatureTitle",
    description: "FilesWaterMarkPriceFeature",
    img: fileWaterMarks,
  },
  {
    title: "FastWaterMarkPriceFeatureTitle",
    description: "FastWaterMarkPriceFeature",
    img: FastWaterMarks,
  },
];

export const MoreFeatures: MoreFeatureItem[] = [
  { title: "EditingTitle", description: "EditingFeature", img: editingcontrol },
  { title: "QRTitle", description: "QRFeature", img: qr },
  { title: "DarkTitle", description: "DarkFeature", img: dark },
  { title: "MultilingualTitle", description: "MultilingualFeature", img: multi },
  { title: "UserFriendlyTitle", description: "UserFriendlyFeature", img: friendly },
  { title: "ResolutionTitle", description: "ResolutionFeature", img: resolution },
  { title: "EXIFTitle", description: "EXIFFeature", img: exif },
  { title: "TrustedTitle", description: "TrustedFeature", img: trusted },
  { title: "MultipleTitle", description: "MultipleFeature", img: multiple },
];
